import { useCallback, useMemo } from 'react';
import { Doors } from 'shared/components/Doors';
import { ALL_DOORS } from 'shared/constants/doors';
import { DoorContainer } from '../DoorContainer';
import { useSelector } from 'react-redux';
import { selectUser } from 'shared/selectors/user';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { EUserStatus } from 'shared/types/user';

export const DoorsContainer: React.FC = () => {
  const { user, status } = useSelector(selectUser);

  const isLoading = status === EUserStatus.Loading;

  const doors = useMemo(
    () => ALL_DOORS.map(item => <DoorContainer key={item.date} isLoading={isLoading} doorId={item.id} {...item} />),
    [isLoading],
  );

  const isAllDoorsOpened = useMemo(() => Boolean(user?.doors.every(item => item.status)), [user?.doors]);

  const {
    config,
    custom: { cianUserId },
  } = useApplicationContext();

  const adminsIds = useMemo(
    () => config.get<number[]>('b2b-marketing-advent-calendar-frontend.adminsIds') || [],
    [config],
  );

  const isAdmin = useMemo(() => adminsIds.includes(cianUserId), [adminsIds, cianUserId]);

  const canShowPointsButton = useMemo(() => isAllDoorsOpened || isAdmin, [isAllDoorsOpened, isAdmin]);

  const token = config.get<string>('b2b-marketing-advent-calendar-frontend.pointsToken');

  const onPointsBtnClick = useCallback(() => {
    window.location.href = `${window.location.href.split('#')[0]}?token=${token}`;
  }, [token]);

  return <Doors onPointsBtnClick={onPointsBtnClick} doors={doors} user={user} isAllDoorsOpened={canShowPointsButton} />;
};
